const selectors = {
    wizards: (state) => {
        return state.wizard.wizards
    },
    wizardName: (router) => router && router.query && router.query.id,
    thisWizard: ({ state, router }) => {
        const wizards = selectors.wizards(state)
        const wizardName = selectors.wizardName(router)

        return wizards[wizardName]
    }
}

export default selectors
